// src/services/cookieService.js
import Cookies from "js-cookie";

const DEFAULTS = {
    sameSite: "None",
    secure: true,
    path: "/",
};

const DEVICE_COOKIE = "app_device_id";

export const cookieService = {
    get(name = DEVICE_COOKIE) {
        return Cookies.get(name);
    },
    set(value, name = DEVICE_COOKIE, opts = {}) {
        Cookies.set(name, value, { ...DEFAULTS, ...opts });
    },
    ensure(name = DEVICE_COOKIE, valueFactory) {
        let v = Cookies.get(name);
        if (!v) {
            v = typeof valueFactory === "function" ? valueFactory() : valueFactory;
            if (v) Cookies.set(name, v, DEFAULTS);
        }
        return v;
    },
    remove(name = DEVICE_COOKIE, opts = {}) {
        Cookies.remove(name, { path: "/", ...opts });
    },
};